"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sketch = void 0;
var lanternSrc = require("./assets/lantern.png");
var State_1 = require("./State");
var sketch = function (node) { return function (p5) {
    var state;
    var lanternImg;
    p5.preload = function () {
        lanternImg = p5.loadImage(lanternSrc);
    };
    p5.setup = function () {
        var _a = node.getBoundingClientRect(), width = _a.width, height = _a.height;
        console.log({ width: width, height: height });
        p5.createCanvas(width, height);
        state = new State_1.State({ p5: p5, lanternImg: lanternImg, width: width, height: height, speed: 0.5 });
    };
    p5.draw = function () {
        p5.clear();
        state.draw();
    };
}; };
exports.sketch = sketch;
